export default __webpack_public_path__ + "b6671d929231ce4f7389b8f47767159b.svg";